export var BusinessLiveAccessStatus;
(function (BusinessLiveAccessStatus) {
    BusinessLiveAccessStatus["Requested"] = "REQUESTED";
    BusinessLiveAccessStatus["Approved"] = "APPROVED";
    BusinessLiveAccessStatus["Rejected"] = "REJECTED";
})(BusinessLiveAccessStatus || (BusinessLiveAccessStatus = {}));
//# sourceMappingURL=BusinessLiveAccessStatus.js.map